export var menuItems = {
  data: [
    {
      headTitle1: "General",
      headTitle2: "Dashboards,Widgets & Layout.",
      type: "headtitle",
    },
    {
      id: "dashboard_home",
      title: "PLN Management Contract",
      icon: "stroke-menu",
      iconf: "fill-menu",
      type: "link",
      badgeType: "light-primary",
      path: "/management-contract",
      active: false,
    },
    {
      id: "dashboard_finance",
      title: "Finance",
      icon: "stroke-coin",
      iconf: "fill-project",
      type: "link",
      badgeType: "light-primary",
      path: "/finance",
      active: false,
    },
    {
      id: "dashboard_primary_energy",
      title: "Primary Energy",
      icon: "primary",
      iconf: "fill-project",
      type: "link",
      badgeType: "light-primary",
      path: "/primary",
      active: false,
    },
    {
      id: "dashboard_generation",
      title: "Generation",
      icon: "stroke-generation",
      iconf: "fill-layout",
      type: "link",
      badgeType: "light-primary",
      path: "/generation",
      active: false,
    },
    {
      id: "dashboard_transmission",
      title: "Transmission",
      icon: "transmission",
      iconf: "fill-layout",
      type: "link",
      badgeType: "light-primary",
      path: "/transmission",
      active: false,
    },
    {
      id: "dashboard_distribution",
      title: "Distribution",
      icon: "stroke-distribution",
      iconf: "fill-layout",
      type: "link",
      badgeType: "light-primary",
      path: "/distribution",
      active: false,
    },
    {
      id: "dashboard_legal_human_capital",
      title: "Legal & Human Capital",
      icon: "human-capital",
      iconf: "fill-full",
      type: "link",
      badgeType: "light-primary",
      path: "/legal-human-capital",
      active: false,
    },
    {
      id: "dashboard_retail_commerce",
      title: "Retail & Commerce",
      icon: "retail",
      iconf: "retail",
      type: "link",
      badgeType: "light-primary",
      path: "/retail-commerce",
      active: false,
    },
    {
      id: "dashboard_risk",
      title: "Risk",
      icon: "risk",
      iconf: "risk",
      type: "link",
      badgeType: "light-primary",
      path: "/risk",
      active: false,
    },
    {
      id: "dashboard_project_management",
      title: "Project Management",
      icon: "project-management",
      iconf: "project-management",
      type: "link",
      badgeType: "light-primary",
      path: "/project-management",
      active: false,
    },
    {
      id: "dashboard_esg",
      title: "ESG",
      icon: "esg",
      iconf: "fill-layout",
      type: "link",
      badgeType: "light-primary",
      path: "/esg",
      active: false,
    },
    {
      id: "dashboard_strategy",
      title: "Strategy",
      icon: "strategy",
      iconf: "fill-layout",
      type: "link",
      badgeType: "light-primary",
      path: "/strategy",
      active: false,
    },
    {
      id: "dashboard_moonshot",
      title: "Moonshot",
      icon: "moonshot",
      iconf: "fill-layout",
      type: "link",
      badgeType: "light-primary",
      path: "/data-moonshot",
      active: false,
    },
  ],
};
